import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { isEmpty } from 'lodash-es';
import { ProviderOfficeAssociationNotesModalComponent } from '../provider-office-association-notes-modal/provider-office-association-notes-modal.component';
import { ProviderOfficeService } from 'app/core/services/provider-office.service';
import { AuthenticationService } from 'app/core/services/authentication.service';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NoteComponent } from '../note/note.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ListProviderOffice } from 'app/core/models/list-provider-office.model';
import { ProviderOffice } from 'app/core/models/provider-office.model';

@Component({
  selector: 'app-provider-office-association-notes',
  templateUrl: './provider-office-association-notes.component.html',
  styleUrls: ['./provider-office-association-notes.component.scss'],
  imports: [NgbPopover, FaIconComponent, NoteComponent, MatProgressSpinner]
})
export class ProviderOfficeAssociationNotesComponent implements OnInit {
  private providerOfficeService = inject(ProviderOfficeService);
  private modalService = inject(NgbModal);
  private authService = inject(AuthenticationService);

  @Input() providerOffice: ProviderOffice | ListProviderOffice;
  @Input() enablePopover: boolean;

  hasNotes = false;
  loading = false;

  associationNotesModal: NgbModalRef = null;

  ngOnInit() {
    this.hasNotes = !isEmpty(this.providerOffice.notes);
  }

  onClick($event) {
    $event.preventDefault();

    // NOTE: the backdrop/keyboard settings above prevent the dismiss flow
    this.associationNotesModal = this.modalService.open(ProviderOfficeAssociationNotesModalComponent, {
      windowClass: 'wide',
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
    });

    const modalInstance = this.associationNotesModal.componentInstance;
    modalInstance.providerOffice = this.providerOffice;

    this.associationNotesModal.result.then(
      (changes: boolean) => this.handleModalClosed(changes)
    );
  }

  public get linkClass() {
    return this.hasNotes ? 'edit-note' : 'add-note';
  }

  public get linkLabel() {
    return this.hasNotes ? 'View Association Note' : 'Add Association Note';
  }

  public get linkLabelTitle() {
    return this.hasNotes ? 'Edit Association Note' : 'Add Association Note'
  }

  public get displayPopover() {
    return this.enablePopover && this.hasNotes;
  }

  public get canAddNotes() {
    return this.authService.isCaptureAdminUser;
  }

  private loadProviderOffice() {
    this.loading = true;

    this.providerOfficeService.get(this.providerOffice.id).subscribe(providerOffice => {
      this.providerOffice.notes = providerOffice.notes;
      this.hasNotes = !isEmpty(providerOffice.notes);
      this.loading = false;
    })
  }

  private handleModalClosed(changes: boolean) {
    if (changes) {
      this.loadProviderOffice();
    }
  }
}
